import styled from 'styled-components';
import { colors } from '../../../utils/utils';

const ErrorMessage = styled.div`
    font-size: 11px;
    color: ${colors.red.radical_red};
`;

export default ErrorMessage;
